import { render, staticRenderFns } from "./TrainingTable.vue?vue&type=template&id=4a1d1aba"
import script from "./TrainingTable.vue?vue&type=script&lang=js"
export * from "./TrainingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports